module.exports = __webpack_public_path__ + "images/2544be892343e412f27a2169d93bbfd5.svg";